<template>
  <div class="container mx-auto px-6 max-w-4xl py-12 min-h-screen">
    <h2 class="text-3xl font-bold text-gray-800 text-center mb-8">Horários de Atendimento</h2>
    <div class="bg-white rounded-2xl shadow-lg p-8">
      <p class="text-lg text-gray-600 text-center mb-6">
        Nossa equipe está pronta para te atender.
      </p>

      <ul class="space-y-4">
        <li v-for="horario in horarios" :key="horario.dia" class="flex justify-between items-center py-2 border-b last:border-0">
          <span class="text-lg font-semibold">{{ horario.dia }}</span>
          <span class="text-lg text-gray-700">{{ horario.horario }}</span>
        </li>
      </ul>

      <div class="mt-8 text-center">
        <p class="text-gray-500">
          Para agendamentos e atendimento especial, entre em contato conosco.
        </p>
        <a  class="inline-block mt-4 text-emerald-600 font-bold hover:underline">
          <svg xmlns="http://www.w3.org/2000/svg" class="inline-block w-5 h-5 mr-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2.08H4.18A2 2 0 0 1 2 20.92v-3a2 2 0 0 1 2.18-2.08h15.64A2 2 0 0 1 22 16.92zM12 2v16"></path>
          </svg>
          (16) 3211-8330
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const horarios = ref([
  { dia: 'Segunda-feira', horario: '08:00 - 18:00' },
  { dia: 'Terça-feira', horario: '08:00 - 18:00' },
  { dia: 'Quarta-feira', horario: '08:00 - 18:00' },
  { dia: 'Quinta-feira', horario: '08:00 - 18:00' },
  { dia: 'Sexta-feira', horario: '08:00 - 18:00' },
  { dia: 'Sábado', horario: '09:00 - 13:00' },
]);
</script>

<style scoped>
</style>